import template from './procedure.html';
import controller from './procedure.controller';

let procedureComponent = {
    restrict: 'E',
    bindings: {},
    template,
    controller
};

export default procedureComponent;
